import { ViewModel, View, ObservableArray } from "binder"
import { PersonnelTaskManipulationView } from "./personnelTaskManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import moment from "moment";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { SelectRecursive } from "src/common/utilities";

export class PersonnelTaskManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return "مدیریت وظایف";
    }
    GetDefaultView(): View<ViewModel> {
        return new PersonnelTaskManipulationView();
    }
    public getTypeId(): string {
        return "VM-FC1529D7-16F1-40E5-8C0F-7D7D57509D62"
    }

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personnelTasks = ObservableArray.create<PersonnelTask>();
        this.date = moment();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set personnelTasks(v: ObservableArray<PersonnelTask>) { this._personnelTasks = v; } public get personnelTasks(): ObservableArray<PersonnelTask> { return this._personnelTasks; } private _personnelTasks: ObservableArray<PersonnelTask>;
    public set date(v: moment.Moment) {
        this._date = v;
        this.refresh();
    } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;

    async refresh(): Promise<void> {
        await this.loadPersonnelTasks();
    }

    async loadPersonnelTasks(): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetPersonnelTasksByDate', {
                DateTime: this.date
            });

            let tasks = SelectRecursive<any, PersonnelTask>(this, serverResult.PersonnelTasks, x => x.SubTasks, (x, parent) => {
                let task: PersonnelTask = new PersonnelTask(this, parent);
                task.id = x.Id;
                task.prioritySelector.selectById(x.Priority);
                task.statusSelector.selectById(x.Status);
                task.comment = x.Comment;
                task.description = x.Description;
                task.isRecentlyCreated = false;
                return task;
            }, (x, y) => x.subTasks.update(...y));
            this.personnelTasks.update(...tasks);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    createPersonnelTask(): void {
        let newPersonnelTask = new PersonnelTask(this, null);
        newPersonnelTask.date = this.date;
        this.personnelTasks.push(newPersonnelTask);
    }

    removePersonnelTask(personnelTask: PersonnelTask): void {
        this.personnelTasks.remove(personnelTask);
    }
    async removeServerPersonnelTask(personnelTask: PersonnelTask): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/RemovePersonnelTask', {
                Id: personnelTask.id
            });
            if (serverResult.IsSuccessful) {
                await this.messageBoxConfirmSuccess("وظیفه با موفقیت حذف شد.", this.getTitle());
            }
            this.refresh();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }


    async savePersonnelTask(personnelTask: PersonnelTask): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/SynchronizePersonnelTask', {
                PersonnelTasks: SelectRecursive(null, this.personnelTasks, x => x.subTasks, (x, y) => {
                    return {
                        Id: x.id,
                        Description: x.description,
                        Priority: x.priority,
                        Status: x.status,
                        DateTime: x.date,
                        Comment: x.comment,
                        SubTasks: []
                    }
                }, (x, y) => x.SubTasks = y)
            });
            if (serverResult.IsSuccessful) {
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ثبت شد.", this.getTitle());
            }
            this.refresh();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class PersonnelTask extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parentViewModel: PersonnelTaskManipulationViewModel, parent: PersonnelTask) {
        super(parentViewModel);
        this._parentTask = parent;
        this._parentViewModel = parentViewModel;
        this.subTasks = ObservableArray.create<PersonnelTask>();

        this.statusSelector = new PersonnelTaskStatusSelector(this);
        this.statusSelector.onSelectionChanged = selectedStatus => { this.status = selectedStatus?.status };

        this.prioritySelector = new PersonnelTaskPrioritySelector(this);
        this.prioritySelector.onSelectionChanged = selectedPriority => { this.priority = selectedPriority?.priority };

        this.date = parentViewModel.date;
        this.status = 1;
        this.priority = 4;
        this.isRecentlyCreated = true;
    }

    private _parentTask: PersonnelTask;
    private _parentViewModel: PersonnelTaskManipulationViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status; } private _status: number;
    public set statusSelector(v: PersonnelTaskStatusSelector) { this._statusSelector = v; } public get statusSelector(): PersonnelTaskStatusSelector { return this._statusSelector; } private _statusSelector: PersonnelTaskStatusSelector;
    public set priority(v: number) { this._priority = v; } public get priority(): number { return this._priority; } private _priority: number;
    public set prioritySelector(v: PersonnelTaskPrioritySelector) { this._prioritySelector = v; } public get prioritySelector(): PersonnelTaskPrioritySelector { return this._prioritySelector; } private _prioritySelector: PersonnelTaskPrioritySelector;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set subTasks(v: ObservableArray<PersonnelTask>) { this._subTasks = v; } public get subTasks(): ObservableArray<PersonnelTask> { return this._subTasks; } private _subTasks: ObservableArray<PersonnelTask>;
    public set showChildren(v: boolean) { this._showChildren = v; } public get showChildren(): boolean { return this._showChildren; } private _showChildren: boolean;
    public set isRecentlyCreated(v: boolean) { this._isRecentlyCreated = v; } public get isRecentlyCreated(): boolean { return this._isRecentlyCreated; } private _isRecentlyCreated: boolean;

    toggleDetail() {
        this.showChildren = !this.showChildren;
    }

    loadSelectors(): void {
        this.prioritySelector.selectById(this.priority.toString());
        this.statusSelector.selectById(this.status.toString());
    }
    createSubTask(): void {
        let newPersonnelTask = new PersonnelTask(this._parentViewModel, this);
        newPersonnelTask.date = this.date;
        this.subTasks.push(newPersonnelTask);
        this.showChildren = true;
    }

    remove(): void {
        if (this.isRecentlyCreated) {
            if (this._parentTask == null) {
                this._parentViewModel.removePersonnelTask(this);
            } else {
                this._parentTask.removeChild(this);
            }
        } else {
            this._parentViewModel.removeServerPersonnelTask(this);
        }
    }

    removeChild(subTask: PersonnelTask) {
        this.subTasks.remove(subTask);
    }

    save(): void {
        this._parentViewModel.savePersonnelTask(this);
    }
}
export class PersonnelTaskStatusSelector extends SelectorBaseViewModel<PersonnelTaskStatus> {
    constructor(parent: ViewModel) {
        super(parent);

    }

    protected async loadData(): Promise<PersonnelTaskStatus[]> {
        let status = [
            { status: 1, title: "جدید" },
            { status: 2, title: "در حال انجام" },
            { status: 3, title: "کامل" },
            { status: 4, title: "ناتمام" }
        ]

        return status.map(item => {
            let s = new PersonnelTaskStatus(this);
            s.id = item.status.toString();
            s.title = item.title;
            s.status = item.status;
            return s;
        })
    }

}
export class PersonnelTaskStatus extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set status(v: number) { this._status = v; } public get status(): number { return this._status; } private _status: number;
}

export class PersonnelTaskPrioritySelector extends SelectorBaseViewModel<PersonnelTaskPriority> {
    constructor(parent: ViewModel) {
        super(parent);

    }

    protected async loadData(): Promise<PersonnelTaskPriority[]> {
        let priorites = [
            { priority: 1, title: "فوری" },
            { priority: 2, title: "زیاد" },
            { priority: 3, title: "متوسط" },
            { priority: 4, title: "کم" }
        ]

        return priorites.map(item => {
            let s = new PersonnelTaskPriority(this);
            s.id = item.priority.toString();
            s.title = item.title;
            s.priority = item.priority;
            return s;
        })
    }

}
export class PersonnelTaskPriority extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set priority(v: number) { this._priority = v; } public get priority(): number { return this._priority; } private _priority: number;
}